import { ICompleteData, IQuoteAction, IQuoteActions, IQuoteState } from './models';
import * as api from '../../data/api/api';
import * as uuid from 'uuid/v4';
import { ICustomer, IPolicyApplication, IProduct, IQuotes } from '../../data/api/models';
import { IStore } from '../../redux/IStore';
import { change, getFormValues } from 'redux-form';
import { cloneDeep, forEach, get } from 'lodash';
import { IBrandingState } from '../branding/models';

const initialState: IQuoteState = {
  startQuoteProcess: false,
  isCalculating: false,
  initialised: false,
  application: {
    id: '',
    startDate: '',
    endDate: '',
    backdatedCover: false,
    schemeId: '',
    quoteReference: '',
    payOnAccount: false,
    steps: ['declaration'],
    generateDocuments: false,
    emailSend: true,
    customer: {
      title: '',
      firstName: '',
      lastName: '',
      dob: '',
      phone1: '',
      email: '',
      address: {
        line1: '',
        line2: '',
        town: '',
        county: '',
        postcode: '',
      },
    },
    insured: {
      id: uuid(),
      title: '',
      firstName: 'Test',
      lastName: 'Test',
      dob: '',
      phone1: '',
      email: '',
      emailConfirmation: '',
      companyName: '',
      address: {
        line1: '',
        line2: '',
        line3: '',
        town: '',
        county: '',
        postcode: '',
      },
      metadata: {
        status: '',
        microEnterprise: '',
        tradingName: '',
        companyRegistrationNumber: '',
        year: '',
        typeOfLicence: '',
        lengthOfLicence: '',
        claims: [],
        convictions: [],
      },
    },
    declaration: {
      1: '',
      2: '',
      3: '',
      5: 'ncd',
      6: '',
      7: '',
      8: '',
      9: '',
      10: '',
      11: '',
      12: 'false',
      13: '',
      14: '',
      15: '',
      16: '',
      17: '',
      18: '',
    },
    declarationTradeVehicle: false,
    vehicleCount: 0,
    vehicles: [],
    personalCustomer: null,
    customerType: '',
    tenure: 0,
    voluntaryExcess: '0',
    voluntaryExcessEnabled: '',
    driverCount: 0,
    drivers: [],
    purchaseDeclarationString: '',
    quickQuote: false,
    contractingPercentage: '1% - 10%',
    nonEquineTrade: '',
    policyDeclaration: false,
    enrichment: {
      companyName: '',
      status: null,
      data: null,
      refer: false,
    },

    excessOverrides: {
      vehicle: {
        cars: [],
        agricultural: [],
        horseboxes: [],
        commercial: [],
        trailers: [],
      },
      driver: [],
    },
    rateOverrides: {
      vehicle: {
        cars: [],
        agricultural: [],
        horseboxes: [],
        commercial: [],
        trailers: [],
      },
      overall: 100,
      driver: [],
    },
    compulsoryExcess: null,

    paymentSchedule: 'annual',

    ignoreReferrals: {},
    postcodeReferrals: {
      decline: false,
      refer: false,
    },
    vehicleReferrals: {
      bodyTypeRefer: false,
      bodyTypeDecline: false,
      vehicleAge: false,
      vehicleValue: false,
    },
    tempDriver: {
      title: '',
      firstName: '',
      lastName: '',
      hasNoNameYet: false,
    },
  },
  quotes: {},
  policy: null,
  complete: null,
  isRetrievingQuote: false,
  errorMessage: null,
  annualGrossPremium: 0,
  annualGrossPremiumForPeriod: 0,
  biannualGrossPremiumForPeriod: 0,
  extraDocuments: {
    propositionAssurance: '',
    conditionsGenerale: '',
  },
  biannualFirstAmount: 0,
  existingCustomer: {
    hasCustomer: false,
    checked: false,
    showModal: false,
    email: '',
    status: null,
  },
  enrichmentResults: null,
};

export const getInitialState = () => {
  return initialState;
};

const INIT = 'b2c/quote/INIT';
const START_QUOTE_PROCESS = 'b2c/quote/START_QUOTE_PROCESS';
const END_QUOTE_PROCESS = 'b2c/quote/END_QUOTE_PROCESS';
const SET_STEPS = 'b2c/quote/SET_STEPS';
const SET_APPLICATION = 'b2c/quote/SET_APPLICATION';
const SET_CUSTOMER = 'b2c/quote/SET_CUSTOMER';
const SET_QUOTE_STEPS = 'b2c/quote/SET_QUOTE_STEPS';
const SET_IS_CALCULATING = 'b2c/quote/SET_IS_CALCULATING';
const SET_QUOTES = 'b2c/quote/SET_QUOTES';
const SET_POLICY = 'b2c/quote/SET_POLICY';
const SET_BROKER_ID = 'b2c/quote/SET_BROKER_ID';
const COMPLETE = 'b2c/quote/COMPLETE';
const COMPLETE_DOCUMENTS = 'b2c/quote/COMPLETE_DOCUMENTS';
const RESET = 'b2c/quote/RESET';
const RETRIEVE_QUOTE = 'b2c/quote/RETRIEVE_QUOTE';
const UPDATE_APPLICATION = 'b2c/quote/UPDATE_APPLICATION';
const SET_ERROR_MESSAGE = 'b2c/quote/b2c/quote/SET_ERROR_MESSAGE';
const SET_ANNUAL_GROSS_PREMIUM = 'b2c/quote/SET_ANNUAL_GROSS_PREMIUM';
const SET_PREMIUMS_BY_PAYMENT_SCHEDULE = 'b2c/quote/SET_PREMIUMS_BY_PAYMENT_SCHEDULE';
const SET_BI_ANNUAL_FIRST_AMOUNT = 'b2c/quote/SET_BI_ANNUAL_FIRST_AMOUNT';
const SET_CUSTOMER_EXISTS = 'b2c/quote/SET_CUSTOMER_EXISTS';
const OPEN_EXISTING_CUSTOMER_MODAL = 'b2c/quote/OPEN_EXISTING_CUSTOMER_MODAL';
const CLOSE_EXISTING_CUSTOMER_MODAL = 'b2c/quote/CLOSE_EXISTING_CUSTOMER_MODAL';
const RESET_EXISTING_CUSTOMER_CHECK = 'b2c/quote/RESET_EXISTING_CUSTOMER_CHECK';
const SET_ENRICHMENT_RESULTS = 'b2c/quote/SET_ENRICHMENT_RESULTS';

export function reducer(state: IQuoteState = initialState, action: IQuoteAction): IQuoteState {
  switch (action.type) {
    case START_QUOTE_PROCESS:
      return {
        ...state,
        startQuoteProcess: true,
      };
    case END_QUOTE_PROCESS:
      return {
        ...state,
        startQuoteProcess: false,
      };
    case INIT:
      return {
        ...state,
        initialised: true,
        application: {
          ...action.payload,
        },
      };
    case SET_APPLICATION:
      return {
        ...state,
        application: action.payload.application,
        customer: action.payload.application.customer,
      };
    case SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload.customer,
      };
    case SET_IS_CALCULATING:
      return {
        ...state,
        isCalculating: action.payload.isCalculating,
      };
    case SET_QUOTES:
      return {
        ...state,
        quotes: action.payload.quotes,
      };
    case SET_POLICY:
      return {
        ...state,
        policy: action.payload.policy,
      };
    case SET_BROKER_ID:
      return {
        ...state,
        application: {
          ...state.application,
          brokerId: action.payload,
        },
      };
    case SET_QUOTE_STEPS:
      return {
        ...state,
        application: {
          ...state.application,
          steps: action.payload,
        },
      };
    case COMPLETE:
      return {
        ...state,
        complete: action.payload,
        errorMessage: null,
      };
    case COMPLETE_DOCUMENTS:
      return {
        ...state,
        complete: {
          ...state.complete,
          documents: action.payload,
        },
      };
    case SET_STEPS:
      return {
        ...state,
        application: {
          ...state.application,
          steps: action.payload.steps,
        },
      };
    case UPDATE_APPLICATION:
      return {
        ...state,
        application: {
          ...state.application,
          ...action.payload,
        },
      };
    case RETRIEVE_QUOTE:
      return {
        ...state,
        isRetrievingQuote: true,
        application: action.payload,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload.message,
      };
    case SET_ANNUAL_GROSS_PREMIUM:
      return {
        ...state,
        annualGrossPremium: action.payload.gross,
      };
    case SET_PREMIUMS_BY_PAYMENT_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_BI_ANNUAL_FIRST_AMOUNT:
      return {
        ...state,
        biannualFirstAmount: action.payload,
      };
    case SET_CUSTOMER_EXISTS:
      return {
        ...state,
        existingCustomer: {
          hasCustomer: action.payload.exists,
          showModal: action.payload.exists,
          email: action.payload.email,
          status: action.payload.status,
          checked: true,
        },
      };
    case CLOSE_EXISTING_CUSTOMER_MODAL:
      return {
        ...state,
        existingCustomer: {
          ...state.existingCustomer,
          showModal: false,
        },
      };
    case OPEN_EXISTING_CUSTOMER_MODAL:
      return {
        ...state,
        existingCustomer: {
          ...state.existingCustomer,
          showModal: true,
        },
      };
    case RESET_EXISTING_CUSTOMER_CHECK:
      return {
        ...state,
        existingCustomer: {
          hasCustomer: false,
          showModal: false,
          checked: false,
          status: null,
          email: '',
        },
      };
    case SET_ENRICHMENT_RESULTS:
      return {
        ...state,
        enrichmentResults: action.payload,
      };
    case RESET:
      return cloneDeep(initialState);
    default:
      return state;
  }
}

const startQuoteProcess = () => ({ type: START_QUOTE_PROCESS });
const endQuoteProcess = () => ({ type: END_QUOTE_PROCESS });

const setPassword = (password: string, passwordConfirmation: string) => (dispatch, getState) => {
  dispatch(change('quote', 'password', password));
  dispatch(change('quote', 'passwordConfirmation', passwordConfirmation));
};

const submitForm = (formValues,
                    calculate = false,
                    fromReduxFormValues = false,
                    patch = false) => (dispatch, getState) => {
  const state: IStore = getState();
  const { branding, quote } = state;
  let values = formValues ? formValues : quote.application;

  if (fromReduxFormValues) {
    values = getFormValues('quote')(state);
  }

  const promise = quote.application.id ?
    api.updatePolicyApplication(values, { calculate, patch })
    : api.createPolicyApplication(values, branding.channel.id, null, { calculate });

  return promise
    .then((application: IPolicyApplication) => {
      forEach(application, (value, key) => dispatch(change('quote', key, value)));

      dispatch(setApplication(application));
    });
};

const saveQuote = (calculate = false) => (dispatch, getState) => {
  const state: IStore = getState();
  const { branding } = state;
  const values = getFormValues('quote')(state);

  const promise = api.saveQuote(values, branding.channel.id, { calculate });

  return promise
    .then((application: IPolicyApplication) => {
      forEach(application, (value, key) => dispatch(change('quote', key, value)));

      dispatch(setApplication(application));
    });
};

const retrieveQuote = (quote) => (dispatch) => {
  return dispatch({ type: RETRIEVE_QUOTE, payload: { quote } });
};

const loadCustomer = () => (dispatch) => {
  return api.getCustomer()
    .then((customer: ICustomer) => {
      dispatch(setCustomer(customer));
    });
};

const calculate = (formValues = null, fromReduxFormValues = false) => (dispatch, getState) => {
  const state: IStore = getState();
  const { quote } = state;
  let values = formValues ? formValues : quote.application;

  if (! values.id && quote.application.id) {
    values.id = quote.application.id;
  }

  dispatch(setIsCalculating(true));

  if (fromReduxFormValues) {
    values = getFormValues('quote')(state);
  }

  return api.updatePolicyApplication(values, { calculate: true })
    .then((application: IPolicyApplication) => {
      dispatch(setIsCalculating(false));
      dispatch(setApplication(application));
      dispatch(setQuotes(application.quotes));
      dispatch(setCustomer(application.customer));
    });
};

const setBrokerId = (brokerId) => ({ type: SET_BROKER_ID, payload: brokerId });
const setApplication = (application: IPolicyApplication) => ({ type: SET_APPLICATION, payload: { application } });
const setCustomer = (customer: ICustomer) => ({ type: SET_CUSTOMER, payload: { customer } });
const setQuotes = (quotes: IQuotes): IQuoteAction => ({ type: SET_QUOTES, payload: { quotes } });
const setPolicy = (policy): IQuoteAction => ({ type: SET_POLICY, payload: { policy } });
const reset = (): IQuoteAction => ({ type: RESET });
const updateApplication = (values: any): IQuoteAction => ({ type: UPDATE_APPLICATION, payload: values });
const error = (message: any): IQuoteAction => ({ type: SET_ERROR_MESSAGE, payload: { message } });

const addStepToWizard = (step: string, formOnly = true): IQuoteAction => (dispatch, getState) => {
  const state: IStore = getState();
  const currentSteps = state.quote.application.steps;

  if (currentSteps.indexOf(step) > -1) {
    return null;
  }

  const steps = [
    ...currentSteps,
    step,
  ];

  dispatch(change('quote', 'steps', steps));

  if (! formOnly) {
    dispatch({ type: SET_STEPS, payload: { steps } });
  }
};

const setIsCalculating = (isCalculating: boolean): IQuoteAction =>
  ({ type: SET_IS_CALCULATING, payload: { isCalculating } });

// The policy can only be issued once the API reports the payment as taken (or not required). A card payment that
// needs the provider's page rejects with the 'redirect-to-provider' error; purchase is called again after it completes.
const purchase = (application) => (dispatch, getState) => {
  const state: IStore = getState();

  return api.getPolicyApplicationPaymentStatus(application)
    .then((paymentStatus) => {
      switch (paymentStatus.status) {
        case 'payment-taken':
        case 'payment-not-required':
          return api.issuePolicyApplication(application, get(paymentStatus, 'data.customer_payment_method_id'));
        case 'payment-required':
          return api.takePaymentForPolicyApplication(application, state.branding.channel.key)
            .then((payment) => api.issuePolicyApplication(application, payment.customer_payment_method_id));
        case 'issued':
          return Promise.reject(new Error('This quote has already been purchased.'));
        default:
          return Promise.reject(new Error('This quote can no longer be purchased, please check your details.'));
      }
    })
    .then((data) => {
      dispatch(setPolicy(data));
      return data;
    });
};

const complete = (data: ICompleteData) => ({
  type: COMPLETE,
  payload: {
    ...data,
  },
});

const completeDocuments = (data: ICompleteData) => ({
  type: COMPLETE_DOCUMENTS,
  payload: {
    ...data,
  },
});

export const getInitValues = (product: IProduct, quoteState: IQuoteState, brandingState: IBrandingState) => {
  // const tripType = Object.keys(product.metadata.trip_type)[0];
  // const groupType = '';
  // const campaignCode = quoteState.campaignCode ? quoteState.campaignCode : null;

  return {
    ...cloneDeep(initialState.application),
    // tripType,
    // groupType,
    // campaignCode,
  };
};

const initFromProduct = (product: IProduct, quoteState: IQuoteState, brandingState: IBrandingState) => {
  const data = getInitValues(product, quoteState, brandingState);
  return {
    type: INIT,
    payload: {
      ...data,
    },
  };
};

const pollPolicyDocuments = (documentsPollToken) => (dispatch) => {
  return api.documentsPoll(documentsPollToken);
};

const referralQuote = (id, referrals) => () => {
  return api.referralQuote(id, referrals);
};

const setAnnualGrossPremium = (gross) => ({
  type: SET_ANNUAL_GROSS_PREMIUM,
  payload: {
    gross,
  },
});

const getPremiumsByPaymentSchedules = (product: IProduct) => (dispatch, getState) => {
  const state: IStore = getState();
  // const { quote } = state;

  const values = getFormValues('quote')(state);

  return api.getPremiumsByPaymentSchedules(product, values)
    .then((data) => {
      dispatch(setPremiumsByPaymentSchedules(data));

      return data;
    });
};

const setPremiumsByPaymentSchedules = (data) => ({
  type: SET_PREMIUMS_BY_PAYMENT_SCHEDULE,
  payload: data,
});

const setBiAnnualFirstAmount = (data) => ({
  type: SET_BI_ANNUAL_FIRST_AMOUNT,
  payload: data,
});

const setSteps = (steps) => ({ type: SET_QUOTE_STEPS, payload: steps });
const closeExistingCustomerModal = () => ({ type: CLOSE_EXISTING_CUSTOMER_MODAL });
const openExistingCustomerModal = () => ({ type: OPEN_EXISTING_CUSTOMER_MODAL });
const resetExistingCustomerCheck = () => ({ type: RESET_EXISTING_CUSTOMER_CHECK });

const checkExistingCustomer = (email) => (dispatch, getState) => {
  return api.checkExistingCustomer({ data: { attributes: { email }}})
    .then((data) => {
      dispatch({
        type: SET_CUSTOMER_EXISTS,
        payload: {
          exists: data.meta.exists,
          status: data.meta.status,
          email,
        },
      });
    });
};

const enrichmentCheck = (
  address,
  companyName,
  companyRegistrationNumber,
  vehicles,
  renewal,
) => (dispatch, getState) => {
  return api.enrichmentCheck(address, companyName, companyRegistrationNumber, vehicles, renewal)
    .then((data) => {
      data.status = 'finished';
      data.company_name = companyName;
      dispatch({
        type: SET_ENRICHMENT_RESULTS,
        payload: data,
      });
      return data;
    });
};

export const actions: IQuoteActions = {
  startQuoteProcess,
  endQuoteProcess,
  submitForm,
  saveQuote,
  retrieveQuote,
  initFromProduct,
  calculate,
  purchase,
  complete,
  completeDocuments,
  reset,
  pollPolicyDocuments,
  addStepToWizard,
  setPassword,
  setApplication,
  setQuotes,
  setCustomer,
  updateApplication,
  error,
  setBrokerId,
  referralQuote,
  setAnnualGrossPremium,
  setPremiumsByPaymentSchedules,
  getPremiumsByPaymentSchedules,
  setBiAnnualFirstAmount,
  setSteps,
  checkExistingCustomer,
  closeExistingCustomerModal,
  openExistingCustomerModal,
  resetExistingCustomerCheck,
  enrichmentCheck,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/quote/reducer.ts